import { SET_FAVORITE_ROUTE } from "./actionTypes";

const initialState = {
  currentFavoriteRoute: "yeuthich-dangdienra",
};

export const FixtureFavoriteRouteReducer = (
  state: any = initialState,
  action: any
) => {
  switch (action.type) {
    case SET_FAVORITE_ROUTE:
      return {
        ...state,
        currentFavoriteRoute: action.payload,
      };
    default:
      return state;
  }
};

export default FixtureFavoriteRouteReducer;
